import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const Duplicate = ({ style, children, ...props }: SvgIconProps) => (
  <SvgIcon {...props} style={{ ...style, fill: "none" }} viewBox="0 0 18 18">
    {children}
    <path d="M3 15.75C2.5875 15.75 2.23438 15.6031 1.94063 15.3094C1.64687 15.0156 1.5 14.6625 1.5 14.25V9H3V14.25H9.75V15.75H3ZM6 12.75C5.5875 12.75 5.23438 12.6031 4.94063 12.3094C4.64688 12.0156 4.5 11.6625 4.5 11.25V6H6V11.25H12.75V12.75H6ZM9 9.75C8.5875 9.75 8.23438 9.60313 7.94063 9.30938C7.64688 9.01563 7.5 8.6625 7.5 8.25V3.75C7.5 3.3375 7.64688 2.98438 7.94063 2.69063C8.23438 2.39687 8.5875 2.25 9 2.25H15C15.4125 2.25 15.7656 2.39687 16.0594 2.69063C16.3531 2.98438 16.5 3.3375 16.5 3.75V8.25C16.5 8.6625 16.3531 9.01563 16.0594 9.30938C15.7656 9.60313 15.4125 9.75 15 9.75H9ZM9 8.25H15V5.25H9V8.25Z" fill="#1976D2"/>
  </SvgIcon>
);

export default Duplicate;
